import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useAppStore } from '../stores/app.js'

export function useTheme() {
  const store = useAppStore()
  const { theme } = storeToRefs(store)
  const isDark = computed(() => theme.value === 'dark')

  function applyTheme(value, persist = true) {
    const next = value === 'dark' ? 'dark' : 'light'
    store.theme = next
    document.documentElement.dataset.theme = next
    document.documentElement.style.colorScheme = next
    if (persist) {
      localStorage.setItem('simbill-theme', next)
      localStorage.setItem('adminDarkMode', next === 'dark' ? '1' : '0')
    }
    window.dispatchEvent(new CustomEvent('simbill:theme', { detail: next }))
  }

  function initialiseTheme() {
    const saved = localStorage.getItem('simbill-theme')
    const legacy = localStorage.getItem('adminDarkMode')
    const preferred = window.matchMedia?.('(prefers-color-scheme: dark)').matches
    applyTheme(saved || (legacy === '1' ? 'dark' : preferred ? 'dark' : 'light'), false)
  }

  function toggleTheme() {
    applyTheme(isDark.value ? 'light' : 'dark')
  }

  return { theme, isDark, applyTheme, initialiseTheme, toggleTheme }
}
